import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { periodicidadeMensal } from '../../../../../shared';
import { ClienteAnaliseMercadoProjecaoClassificacaoSearch } from '../cliente-analise-mercado-projecao-classificacao-search';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoProjecaoClassificacaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado/projecao/classificacao`;
    }

    /** Realiza a pesquisa das projeções das classificações dos clientes nas análises de mercados */
    search(idCliente: number, mes: number, ano: number, statusProjetado: number, idEtapaNegociacaoProjecao: number): Observable<ClienteAnaliseMercadoProjecaoClassificacaoSearch[]> {
        let params = new HttpParams();
        // Cliente
        if (idCliente) {
            params = params.append('idCliente', idCliente.toString());
        }
        // Periodicidade
        params = params.append('periodicidade', periodicidadeMensal.id.toString());
        // Mês
        if (mes) {
            params = params.append('mes', mes.toString());
        }
        // Ano
        if (ano) {
            params = params.append('ano', ano.toString());
        }
        // Status Projetado
        if (statusProjetado) {
            params = params.append('statusProjetado', statusProjetado.toString());
        };
        // Etapas Negociações Projeções
        if (idEtapaNegociacaoProjecao) {
            params = params.append('idEtapaNegociacaoProjecao', idEtapaNegociacaoProjecao.toString());
        };

        return this.customHttp.get<ClienteAnaliseMercadoProjecaoClassificacaoSearch[]>(this.pathApi, {params});
    }


    /** Remove a projeção de venda mensal do lançamento da classificação na análise de mercado */
    removeProjecaoMensal(idClienteAnaliseMercadoClassificacao: number, mes: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${idClienteAnaliseMercadoClassificacao}/mes/${mes}`, null);
    }
}
